// extracted by mini-css-extract-plugin
module.exports = {"Container":"AuthLayout_Container__2AItQ","Banner":"AuthLayout_Banner__2LxY1","Content":"AuthLayout_Content__2zaky","Logo":"AuthLayout_Logo__2NLPB"};